// Cálculo de Fcj (resistência à compressão obtida no ensaio) e Fcj Esp (resistência
// característica esperada na idade de ruptura), usados no relatório sequencial.

// fcj = carga de ruptura x ponderador do tipo de carga x ponderador do tipo de corpo de prova.
export function calcularFcj({ valrCarga, ponderadorTipoCarga, ponderadorTipoCorpoProva }) {
  if (valrCarga == null || ponderadorTipoCarga == null || ponderadorTipoCorpoProva == null) return null;
  const valor = Number(valrCarga) * Number(ponderadorTipoCarga) * Number(ponderadorTipoCorpoProva);
  return Number.isFinite(valor) ? valor : null;
}

// Resistência esperada na idade de ruptura, a partir do Fck (CRC): fck * exp{S*(1-sqrt(28/idade))}.
// S é o ponderador cadastrado no Tipo de Cimento (src/pages/CadastrosTecnicosPage.js); sem ele, não há cálculo.
export function calcularFcjEsperado({ fck, idade, ponderadorTipoCimento }) {
  if (fck == null || !idade || Number(idade) <= 0 || ponderadorTipoCimento == null) return null;
  const s = Number(ponderadorTipoCimento);
  const valor = Number(fck) * Math.exp(s * (1 - Math.sqrt(28 / Number(idade))));
  return Number.isFinite(valor) ? valor : null;
}

// Resistência média esperada na idade de ruptura: (fck + 6,6) * exp{S*(1-sqrt(28/idade))}.
// Usada apenas para os limiares de cor (azul/verde), não é exibida como coluna.
export function calcularFcmj({ fck, idade, ponderadorTipoCimento }) {
  if (fck == null || !idade || Number(idade) <= 0 || ponderadorTipoCimento == null) return null;
  const s = Number(ponderadorTipoCimento);
  const valor = (Number(fck) + 6.6) * Math.exp(s * (1 - Math.sqrt(28 / Number(idade))));
  return Number.isFinite(valor) ? valor : null;
}

// Classifica o fcj obtido conforme as faixas em relação a fcmj (média) e fcj,esp (característico):
// azul >= 120% fcmj; verde >= 95% fcmj; amarelo entre 95% fcj,esp e 95% fcmj; vermelho <= 95% fcj,esp.
export function classificarFcj({ fcj, fcmj, fcjEsperado }) {
  if (fcj == null || fcmj == null || fcjEsperado == null) return null;
  if (fcj >= 1.20 * fcmj) return 'azul';
  if (fcj >= 0.95 * fcmj) return 'verde';
  if (fcj > 0.95 * fcjEsperado) return 'amarelo';
  return 'vermelho';
}

// Cor de fundo da célula do Fcj, por categoria.
export const CORES_FCJ = {
  azul: '#0000FF',
  verde: '#008000',
  amarelo: '#FFFF00',
  vermelho: '#FF0000',
};

// Cor do texto (número) da célula do Fcj, por categoria — escolhida manualmente
// (tom mais escuro da cor de fundo correspondente em CORES_FCJ).
export const CORES_FCJ_TEXTO = {
  azul: '#00008B',
  verde: '#006400',
  amarelo: '#FF8C00',
  vermelho: '#8B0000',
};
